/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-12-02                                                        *
 ******************************************************************************/

export default {
    provide(){
        return{
            registerSortedItemsReceiver: this.registerSortedItemsReceiver,
            setSortedItems: this.setSortedItems
        };
    },
    data(){
        return {
            sorted_items: [],
            sorted_items_receivers:[],
        };
    },
    computed:{
        filtered_sorted_items(){
            if(this.filtered_items_receivers.length > 0){
                return this.sorted_items;
            }else{
                return this.filtered_items;
            }
        }
    },
    methods:{
        registerSortedItemsReceiver(component){
            this.sorted_items_receivers.push(component);
        },
        setSortedItems(sorted_items){
            this.sorted_items = sorted_items;
            this.sorted_items_receivers.forEach((component)=>{
                component.setSortedItems(sorted_items);
            });
        },
    }
}
